import deepmerge from 'deepmerge'

export default deepmerge(
  {
    config: {
      iframe: false,
      feed_id: '',
      element_id: 'app',
      allow_orders: true,
      allow_delivery: false,
      allow_pickup: true,
      kiosk_mode: false,
      mock_button: false
    },
    style: {
      theme: 'light',
      grid_view: true,
      heading_font: 'sans-serif',
      heading_font_color: '#242424',
      body_font: 'sans-serif',
      body_font_color: '#747474',
      color_primary: '#8ac440',
      color_primary_hover: '#689522',
      product_images: true,
      display_brands: true
    }
  },
  window.posabitmenuwidget || {}
)
